export default __webpack_public_path__ + "static/media/by_6.0663fc30.mp3";